import React, { useState } from "react"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import { Link } from "react-router-dom"

const NAVY = "#221C5D"
const RED = "#dc3545"
const ORANGE = "#E56A22"

// Uyarı eşiği: limitin %80'i. Altındaki kalemler listelenmez.
const WARN_RATIO = 0.8

// Okunmamış duyuru ikonundaki parıltının (AnnouncementBanner, abUnreadGlow) daha hafif hali, limit renginde.
const GLOW_CSS = `
  .plan-limit-indicator {
    box-shadow: 0 0 0 1px var(--pli-glow), 0 0 3px 0 var(--pli-glow);
    animation: pliGlow 2.4s ease-in-out infinite;
  }
  @keyframes pliGlow {
    0%, 100% { box-shadow: 0 0 0 1px var(--pli-glow), 0 0 2px 0 var(--pli-glow); }
    50%      { box-shadow: 0 0 0 1px var(--pli-glow), 0 0 6px 1px var(--pli-glow); }
  }
  @media (prefers-reduced-motion: reduce) {
    .plan-limit-indicator { animation: none; }
  }
`

const limitItems = (status) =>
  [
    { key: "accounts", label: "Cari", icon: "bx-user", used: status.currentAccounts, max: status.maxAccounts, blocked: "Yeni cari eklenemez" },
    // Firma admini de alt kullanıcı sayılır; tek haklı pakette 1/1 olağan durumdur, yalnız aşımda uyarılır.
    {
      key: "users",
      label: "Alt kullanıcı",
      icon: "bx-user-circle",
      used: status.currentUsers,
      max: status.maxUsers,
      blocked: "Yeni alt kullanıcı eklenemez",
      onlyWhenExceeded: true,
    },
    {
      key: "accountUsers",
      label: "Cari kullanıcı",
      icon: "bx-group",
      used: status.currentAccountUsers,
      max: status.maxAccountUsers,
      blocked: "Yeni cari kullanıcı eklenemez",
    },
    {
      key: "accountGroups",
      label: "Taksit grubu",
      icon: "bx-layer",
      used: status.currentAccountGroups,
      max: status.maxAccountGroups,
      blocked: "Yeni taksit grubu eklenemez",
    },
  ]
    .filter((item) => item.max != null && item.max > 0 && item.used != null)
    .filter((item) => (item.onlyWhenExceeded ? item.used > item.max : item.used / item.max >= WARN_RATIO))
    .map((item) => ({ ...item, full: item.used >= item.max }))

/**
 * Header'daki küçük limit uyarısı. Limit dolduysa kırmızı, yaklaştıysa turuncu;
 * tıklanınca hangi limitin ne durumda olduğunu gösterir. Uyarılacak kalem yoksa çizilmez.
 */
const PlanLimitIndicator = ({ status }) => {
  const [open, setOpen] = useState(false)
  const items = limitItems(status)
  if (items.length === 0) return null

  const anyFull = items.some((item) => item.full)
  const accent = anyFull ? RED : ORANGE

  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)} className="d-inline-flex align-items-center px-1">
      <style>{GLOW_CSS}</style>
      <DropdownToggle
        tag="button"
        type="button"
        className="btn p-0 d-inline-flex align-items-center justify-content-center plan-limit-indicator"
        title={anyFull ? "Paket limitiniz doldu" : "Paket limitinize yaklaştınız"}
        aria-label="Paket limitleri"
        style={{ width: 30, height: 30, borderRadius: "50%", background: `${accent}1a`, border: 0, "--pli-glow": `${accent}80` }}
      >
        <i className="bx bx-error-circle" style={{ fontSize: 18, color: accent }} />
      </DropdownToggle>

      <DropdownMenu end className="p-0" style={{ width: 290 }}>
        <div className="px-3 py-2 border-bottom">
          <h6 className="m-0" style={{ color: NAVY }}>Paket Limitleri</h6>
          <div className="text-muted" style={{ fontSize: ".75rem" }}>
            {status.planName ? `${status.planName} paket` : "Mevcut paket"} · mevcut kayıtlarınız çalışmaya devam eder
          </div>
        </div>

        {items.map((item) => {
          const color = item.full ? RED : ORANGE
          const percent = Math.min(100, Math.round((item.used / item.max) * 100))
          return (
            <div key={item.key} className="px-3 py-2 border-bottom">
              <div className="d-flex align-items-center justify-content-between" style={{ fontSize: ".85rem" }}>
                <span className="d-inline-flex align-items-center gap-1" style={{ color: "#333", fontWeight: 600 }}>
                  <i className={`bx ${item.icon}`} style={{ color }} />
                  {item.label}
                </span>
                <span style={{ color, fontWeight: 700 }}>
                  {item.used} / {item.max}
                </span>
              </div>
              <div className="progress mt-1" style={{ height: 5 }}>
                <div className="progress-bar" role="progressbar" style={{ width: `${percent}%`, backgroundColor: color }} />
              </div>
              <div className="mt-1" style={{ fontSize: ".72rem", color: item.full ? color : "#6b7280" }}>
                {item.full ? item.blocked : "Limitinize yaklaştınız"}
              </div>
            </div>
          )
        })}

        <div className="p-2 d-flex gap-2">
          <Link
            to="/subscription/plans"
            className="btn btn-sm flex-grow-1"
            style={{ backgroundColor: NAVY, borderColor: NAVY, color: "#fff", borderRadius: 999, fontWeight: 600 }}
            onClick={() => setOpen(false)}
          >
            Paketi Yükselt
          </Link>
          <Link
            to="/subscription/details"
            className="btn btn-sm btn-outline-secondary"
            style={{ borderRadius: 999, fontWeight: 600 }}
            onClick={() => setOpen(false)}
          >
            Aboneliğim
          </Link>
        </div>
      </DropdownMenu>
    </Dropdown>
  )
}

export default PlanLimitIndicator
